export default __webpack_public_path__ + "static/media/executioners_calling.79c04457.png";